module.exports = __webpack_public_path__ + "media/images/gallery/oc_tab_off-1ec4bc897023382897925b94d9db82b8.jpg";